export const EXPLORE_PAGE_SIZE = 35;
export const HOME_EXPLORE_CONTAINER_PAGE_SIZE = 10;
export const MP_HOST = process.env.NODE_ENV === "development" ? "buqo.io" : window.location.hostname